import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();
const HOSTNAME = process.env.REACT_APP_HOSTNAME || 'http://localhost:8080';

export const AuthProvider = ({ children }) => {
  const [accessToken, setAccessToken] = useState(null);
  const [loading, setLoading] = useState(true); // Track if refresh is in progress

  useEffect(() => {
    const tryRefresh = async () => {
      try {
        const res = await fetch(`${HOSTNAME}/api/refresh`, {
          method: 'POST',
          credentials: 'include', // Send refresh token cookie
        });

        if (res.ok) {
          const data = await res.json();
          setAccessToken(data.access_token);
        }
      } catch (err) {
        console.error('Refresh failed:', err);
      } finally {
        setLoading(false);
      }
    };

    tryRefresh();
  }, []);

  const login = async (username, password) => {
    console.log('Login attempt with:', { username, password });
    console.log('Sending to:', `${HOSTNAME}/api/login`);

    const res = await fetch(`${HOSTNAME}/api/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ username, password }),
    });

    console.log('Response status:', res.status);
    console.log('Response ok:', res.ok);

    if (!res.ok) {
      const errorText = await res.text();
      console.error('Login failed with response:', errorText);
      throw new Error('Login failed');
    }

    const data = await res.json();
    console.log('Login successful, received data:', data);
    setAccessToken(data.access_token);
  };

  const logout = async () => {
    await fetch(`${HOSTNAME}/api/logout`, {
      method: 'POST',
      credentials: 'include',
    });
    setAccessToken(null);
  };

  const loginWithToken = (token) => setAccessToken(token);

  return (
    <AuthContext.Provider value={{ accessToken, login, loginWithToken, logout, loading }}>
      {!loading && children} {/* Delay app rendering until refresh is attempted */}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
